import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { OrganizationService } from 'src/app/_services/generatedServices';
import { NavigationService } from 'src/app/_services/navigation-service';
import { SettingsProvider } from 'src/app/_services/settingsProvider.service';
import { PageViewModel, ConferenceViewModel, ConferenceViewModelWithDetails } from 'src/app/_models/generatedModels';
import { Title } from '@angular/platform-browser';
import { AnalyticsService } from 'src/app/_services/analytics.service';

@Component({
  selector: 'bxl-conference-page',
  templateUrl: 'conference-page.component.html',
})
export class ConferencePageComponent implements OnInit, OnDestroy {
  initialized = false;
  found = false;
  private routeSubscription: Subscription;
  private parentRouteSubscription: Subscription;
  isHome = false;

  pageId: any;
  page: PageViewModel;

  conference: ConferenceViewModel;

  constructor(public auth: AuthenticationService, public title: AnalyticsService, public settings: SettingsProvider, private route: ActivatedRoute, private router: Router, public nav: NavigationService, public orgService: OrganizationService) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.paramMap.subscribe((param) => {
        this.pageId = param.get('page');
        let slug = param.get('conferenceSlug');



        this.orgService.getConferenceBySlugBasic(slug).subscribe((conference) => {
          this.conference = conference;
          console.log(this.conference.id);
          console.log(slug);

          this.orgService.getConferencePage(conference.id, this.pageId).subscribe((page) => {
            this.page = page;
            this.title.setTitleAndLogPageView(this.page.navText + ' - ' + this.conference.name);
            this.initialized = true;
            this.found = true;
          },error=>{
            this.initialized = true;
            this.found = false;
          });
        });
      });
  }

  ngOnDestroy(): void {
    console.log('disposing page');

    this.routeSubscription.unsubscribe();
  }
}
